declare var window: any;
import { ControllerBase } from 'controllerBase';
const ko = require('knockout')
import { Paginator } from "paginator";
export const VendedorOrcamentoController = ControllerBase.extend({
    name: "VendedorOrcamentoController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_Vendedor",
            type: "post",
            cache: false
        };
    },

    newModel: function() {
        return {
            Codigo: null,
            Nome: null,
            VendedoresOrcamento: [],
            Vendedores: [],
            VendedoresSelecionados: [],
            VendedoresOrcamentoSelecionados: [],
            incluir: true
        };
    },

    antesBinding: function() {

        if (this.orcamento.get("Vendedores")) {
            var m = ko.mapping.fromJS(this.orcamento.get("Vendedores"));
            this.model.VendedoresOrcamento(m());
            this.model.incluir(false);
        }

    },

    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    antesRenderizacaoCompleta: function() {

        this.botaoLimpar = this.addActionButton({
                text: "Limpar",
                'class': "icone-excluir separador",
                click: $.proxy(function() {

                        this.limpar();

                    },
                    this)
            },
            true);


    },

    limpar: function() {

        global.clearFormFields({ element: this.form });
        this.model.Vendedores(undefined);

    },

    formConfig: {
        selector: "#form-vendedores",
        submit: {
            selector: "#bntPesquisar",
            loadingText: "Aguarde...",
            callback: "pesquisar",
            type: "model",
            modelType: "knockout"
        },
    },

    cancelar: function() {
        this.model.incluir(false);
    },

    pesquisar: function(model, e, page) {

        var self = this;

        var filtros = {
            TamanhoPagina: 20,
            NumeroPagina: page ? page : 1,
            IdentificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
            Codigo: this.model.Codigo(),
            Nome: this.model.Nome()
        };


        global.ajax({
            url: "/Orcamento/ListarVendedores",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function(data) {

                var m = ko.mapping.fromJS(data && data.Entities ? data.Entities : []);

                self.model.Vendedores(m());

                if (data) {
                    this.paginador = new Paginator({
                        container: "#page-vendedor",
                        data: data,
                        pageClickCallback: $.proxy(self.paginar, self)
                    });
                }
            }
        });

    },

    paginar: function(e) {
        this.pesquisar(this.model, null, e.page);
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    selecionar: function(model) {
        model.selecionado(!model.selecionado());


        if (model.selecionado()) {
            this.model.VendedoresSelecionados.push(model);
        } else {
            this.model.VendedoresSelecionados.remove(model);
        }

    },

    adicionar: function() {

        if (!this.model.VendedoresSelecionados ||
            !this.model.VendedoresSelecionados() ||
            this.model.VendedoresSelecionados().length == 0) {
            global.showErrorMessage("Selecione o(s) vendedor(es) a ser(em) adicionado(s).");
            return;
        }

        var self = this;

        var vendedores = this.toJS(this.model.VendedoresSelecionados());

        global.ajax({
            url: "/Orcamento/AdicionarVendedores",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                vendedores: vendedores
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                if (!data.HasErrors) {
                    global.showSuccessMessage("Vendedor(es) adicionado(s) com sucesso");
                }

                var m = ko.mapping.fromJS(data.Vendedores);

                self.model.VendedoresOrcamento(m());
                self.orcamento.set("Vendedores", data.Vendedores);
                self.model.incluir(false);
                self.model.Vendedores.removeAll();
                self.model.VendedoresSelecionados.removeAll();
            }
        });

    },

    selecionarVendedorOrcamento: function(model) {

        model.selecionado(!model.selecionado());


        if (model.selecionado()) {
            this.model.VendedoresOrcamentoSelecionados.push(model);
        } else {
            this.model.VendedoresOrcamentoSelecionados.remove(model);
        }

    },

    incluir: function() {
        this.model.incluir(true);
        if (this.model.Vendedores && this.model.Vendedores()) {
            this.model.Vendedores.removeAll();
        }
        if (this.model.VendedoresSelecionados && this.model.VendedoresSelecionados()) {
            this.model.VendedoresSelecionados.removeAll();
        }

    },

    excluir: function() {

        var self = this;

        var vendedores = this.toJS(this.model.VendedoresOrcamentoSelecionados());

        global.ajax({
            url: "/Orcamento/RemoverVendedores",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                vendedores: vendedores
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                if (!data.HasErrors) {
                    global.showSuccessMessage("Vendedor(es) excluído(s) com sucesso");
                }

                var m = ko.mapping.fromJS(data.Vendedores);

                self.model.VendedoresOrcamento(m());
                self.orcamento.set("Vendedores", data.Vendedores);
                self.model.VendedoresOrcamentoSelecionados.removeAll();

                if (!self.model.VendedoresOrcamento() || self.model.VendedoresOrcamento().length == 0) {
                    self.model.incluir(true);
                }

            }
        });

    }


});

(window as any).VendedorOrcamentoController = VendedorOrcamentoController
